/*
 * Estimated delivery date on the product page (replaces the Simesy EDD app).
 * Computed in the browser from the rules below: no external requests, no
 * cookies, no storage. Values taken 1:1 from the Simesy configuration
 * (2026-10-02): dispatch Mon–Fri with cut-off Mon 15:00 / Tue–Fri 15:15
 * (Europe/Berlin), delivery Mon–Fri, per-country working days.
 * Dispatch skips Bavarian public holidays (warehouse in Regensburg) and
 * 24 Dec; delivery to DE additionally skips German public holidays.
 */
(function () {
  'use strict';

  const CUTOFF = { 1: '15:00', 2: '15:15', 3: '15:15', 4: '15:15', 5: '15:15' };
  // [dispatch min, dispatch max, delivery min, delivery max] in working days
  const COUNTRIES = {
    DE: [0, 0, 1, 2], CH: [0, 1, 2, 5], AT: [0, 1, 2, 4], ES: [0, 1, 4, 6], PT: [0, 1, 4, 6],
    FR: [0, 1, 3, 5], NL: [0, 1, 1, 4], BE: [0, 1, 1, 4], LU: [0, 1, 1, 4], DK: [0, 1, 3, 5],
    SE: [0, 1, 3, 5], FI: [0, 1, 3, 5], PL: [0, 1, 3, 5], CZ: [0, 1, 3, 5], IT: [1, 1, 3, 5],
    LT: [0, 1, 4, 6], LV: [0, 1, 4, 6], EE: [0, 1, 4, 6], BG: [0, 1, 4, 7], GR: [0, 1, 4, 7],
    HU: [0, 1, 4, 7], IE: [0, 1, 4, 7], LI: [0, 1, 4, 7], MT: [0, 1, 4, 7], MC: [0, 1, 4, 7],
    NO: [0, 1, 4, 7], RO: [0, 1, 4, 7], RS: [0, 1, 4, 7], SI: [0, 1, 4, 7], SK: [0, 1, 4, 7],
  };

  const TEXT = {
    de: { head: 'Schneller Versand durch DHL', order: 'Bestellung innerhalb der nächsten {t} für eine Lieferung zwischen {a} und {b}', single: 'Bestellung innerhalb der nächsten {t} für eine Lieferung am {a}', placed: 'Bestellung bestätigt', shipped: 'Bestellung versendet', delivered: 'Bestellung geliefert', h: 'Std.', m: 'Min.', country: 'Lieferland' },
    en: { head: 'Fast shipping with DHL', order: 'Order within the next {t} for delivery between {a} and {b}', single: 'Order within the next {t} for delivery on {a}', placed: 'Order confirmed', shipped: 'Order shipped', delivered: 'Order delivered', h: 'h', m: 'min', country: 'Delivery country' },
    da: { head: 'Hurtig levering med DHL', order: 'Bestil inden for de næste {t} for levering mellem {a} og {b}', single: 'Bestil inden for de næste {t} for levering {a}', placed: 'Ordre bekræftet', shipped: 'Ordre afsendt', delivered: 'Ordre leveret', h: 't.', m: 'min.', country: 'Leveringsland' },
    es: { head: 'Envío rápido con DHL', order: 'Haz tu pedido en las próximas {t} para recibirlo entre el {a} y el {b}', single: 'Haz tu pedido en las próximas {t} para recibirlo el {a}', placed: 'Pedido confirmado', shipped: 'Pedido enviado', delivered: 'Pedido entregado', h: 'h', m: 'min', country: 'País de entrega' },
    fr: { head: 'Expédition rapide avec DHL', order: 'Commandez dans les {t} pour une livraison entre le {a} et le {b}', single: 'Commandez dans les {t} pour une livraison le {a}', placed: 'Commande confirmée', shipped: 'Commande envoyée', delivered: 'Commande livrée', h: 'h', m: 'min', country: 'Pays de livraison' },
    it: { head: 'Spedizione rapida con DHL', order: 'Ordina entro {t} per una consegna tra {a} e {b}', single: 'Ordina entro {t} per una consegna il {a}', placed: 'Ordine confermato', shipped: 'Ordine spedito', delivered: 'Ordine consegnato', h: 'h', m: 'min', country: 'Paese di consegna' },
    nl: { head: 'Snelle verzending met DHL', order: 'Bestel binnen {t} voor levering tussen {a} en {b}', single: 'Bestel binnen {t} voor levering op {a}', placed: 'Bestelling bevestigd', shipped: 'Bestelling verzonden', delivered: 'Bestelling geleverd', h: 'u', m: 'min', country: 'Leveringsland' },
    pl: { head: 'Szybka wysyłka z DHL', order: 'Zamów w ciągu {t}, a dostawa nastąpi między {a} a {b}', single: 'Zamów w ciągu {t}, a dostawa nastąpi {a}', placed: 'Zamówienie potwierdzone', shipped: 'Zamówienie wysłane', delivered: 'Zamówienie dostarczone', h: 'godz.', m: 'min', country: 'Kraj dostawy' },
    pt: { head: 'Envio rápido com DHL', order: 'Encomende nas próximas {t} para entrega entre {a} e {b}', single: 'Encomende nas próximas {t} para entrega a {a}', placed: 'Encomenda confirmada', shipped: 'Encomenda expedida', delivered: 'Encomenda entregue', h: 'h', m: 'min', country: 'País de entrega' },
    sv: { head: 'Snabb frakt med DHL', order: 'Beställ inom {t} för leverans mellan {a} och {b}', single: 'Beställ inom {t} för leverans {a}', placed: 'Order bekräftad', shipped: 'Order skickad', delivered: 'Order levererad', h: 'tim', m: 'min', country: 'Leveransland' },
  };

  // Civil dates are UTC midnight Date objects; only the calendar day matters.
  const day = (y, m, d) => new Date(Date.UTC(y, m - 1, d));
  const addDays = (date, n) => new Date(date.getTime() + n * 86400000);
  const key = date => date.toISOString().slice(0, 10);

  function easterSunday(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), dayOfMonth = ((h + l - 7 * m + 114) % 31) + 1;
    return day(year, month, dayOfMonth);
  }

  const cache = {};
  function holidays(year) {
    if (cache[year]) return cache[year];
    const easter = easterSunday(year);
    const german = [day(year, 1, 1), addDays(easter, -2), addDays(easter, 1), day(year, 5, 1), addDays(easter, 39),
      addDays(easter, 50), day(year, 10, 3), day(year, 12, 25), day(year, 12, 26)];
    const bavaria = german.concat([day(year, 1, 6), addDays(easter, 60), day(year, 8, 15), day(year, 11, 1), day(year, 12, 24)]);
    cache[year] = { german: new Set(german.map(key)), bavaria: new Set(bavaria.map(key)) };
    return cache[year];
  }

  const weekday = date => date.getUTCDay(); // 0 = Sunday
  const isDispatchDay = date => weekday(date) >= 1 && weekday(date) <= 5 && !holidays(date.getUTCFullYear()).bavaria.has(key(date));
  const isDeliveryDay = (date, country) => weekday(date) >= 1 && weekday(date) <= 5
    && !(country === 'DE' && holidays(date.getUTCFullYear()).german.has(key(date)));

  function nextMatching(date, test) {
    let d = date;
    while (!test(d)) d = addDays(d, 1);
    return d;
  }
  function addWorkdays(date, n, test) {
    let d = date;
    for (let i = 0; i < n; i += 1) d = nextMatching(addDays(d, 1), test);
    return d;
  }

  // Wall-clock date and minutes in Europe/Berlin for an instant.
  function berlinParts(instant) {
    const parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(instant).forEach(p => { parts[p.type] = p.value; });
    return { date: day(+parts.year, +parts.month, +parts.day), minutes: +parts.hour * 60 + +parts.minute };
  }
  const cutoffMinutes = date => {
    const [h, m] = CUTOFF[weekday(date)].split(':').map(Number);
    return h * 60 + m;
  };

  function estimate(instant, countryCode) {
    const country = COUNTRIES[countryCode] ? countryCode : 'DE';
    const [dMin, dMax, lMin, lMax] = COUNTRIES[country];
    const now = berlinParts(instant);
    const today = now.date;
    const sameDay = isDispatchDay(today) && now.minutes < cutoffMinutes(today);
    const firstDispatch = sameDay ? today : nextMatching(addDays(today, 1), isDispatchDay);
    const dispatchMin = addWorkdays(firstDispatch, dMin, isDispatchDay);
    const dispatchMax = addWorkdays(firstDispatch, dMax, isDispatchDay);
    const deliveryTest = d => isDeliveryDay(d, country);
    const deliveryMin = addWorkdays(dispatchMin, lMin, deliveryTest);
    const deliveryMax = addWorkdays(dispatchMax, lMax, deliveryTest);
    const daysUntil = Math.round((firstDispatch - today) / 86400000);
    const minutesLeft = daysUntil * 1440 + cutoffMinutes(firstDispatch) - now.minutes;
    return { country, orderDate: today, dispatchMin, dispatchMax, deliveryMin, deliveryMax, minutesLeft };
  }

  const api = { COUNTRIES, CUTOFF, easterSunday, holidays, estimate, key };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }

  // ---------- Storefront rendering ----------
  const lang = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  const t = TEXT[lang] || TEXT.en;
  const fill = (s, v) => s.replace(/\{(\w)\}/g, (_, k) => v[k]);
  const fmt = d => new Intl.DateTimeFormat(document.documentElement.lang || 'de', { weekday: 'short', day: 'numeric', month: 'long', timeZone: 'UTC' }).format(d);
  const range = (a, b) => (key(a) === key(b) ? fmt(a) : fmt(a) + ' – ' + fmt(b));
  const duration = mins => {
    const h = Math.floor(mins / 60), m = mins % 60;
    return (h ? h + ' ' + t.h + ' ' : '') + m + ' ' + t.m;
  };
  const regionName = code => {
    try { return new Intl.DisplayNames([document.documentElement.lang || 'de'], { type: 'region' }).of(code); } catch (e) { return code; }
  };

  function render(root) {
    const select = root.querySelector('select');
    const result = estimate(new Date(), select.value);
    const order = key(result.deliveryMin) === key(result.deliveryMax)
      ? fill(t.single, { t: duration(result.minutesLeft), a: fmt(result.deliveryMin) })
      : fill(t.order, { t: duration(result.minutesLeft), a: fmt(result.deliveryMin), b: fmt(result.deliveryMax) });
    root.querySelector('[data-esv-order]').textContent = order;
    root.querySelector('[data-esv-placed]').textContent = fmt(result.orderDate);
    root.querySelector('[data-esv-shipped]').textContent = range(result.dispatchMin, result.dispatchMax);
    root.querySelector('[data-esv-delivered]').textContent = range(result.deliveryMin, result.deliveryMax);
  }

  function mount(root) {
    if (root.dataset.esvMounted) return;
    root.dataset.esvMounted = '1';
    const initial = COUNTRIES[root.dataset.country] ? root.dataset.country : 'DE';
    const options = Object.keys(COUNTRIES)
      .map(code => ({ code, name: regionName(code) }))
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(o => '<option value="' + o.code + '"' + (o.code === initial ? ' selected' : '') + '>' + o.name + '</option>')
      .join('');
    root.innerHTML =
      '<label class="esv-delivery__country"><span class="visually-hidden">' + t.country + '</span><select>' + options + '</select></label>' +
      '<p class="esv-delivery__head">🚚 ' + t.head + '</p>' +
      '<p class="esv-delivery__order">✅ <span data-esv-order></span></p>' +
      '<ol class="esv-delivery__steps">' +
      '<li><b>' + t.placed + '</b><span data-esv-placed></span></li>' +
      '<li><b>' + t.shipped + '</b><span data-esv-shipped></span></li>' +
      '<li><b>' + t.delivered + '</b><span data-esv-delivered></span></li></ol>';
    root.querySelector('select').addEventListener('change', () => render(root));
    render(root);
    setInterval(() => render(root), 30000);
    root.hidden = root.dataset.available !== 'true';
  }

  function init() {
    const roots = document.querySelectorAll('[data-esv-delivery]');
    roots.forEach(mount);
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.productVariantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.productVariantChange, ({ variant }) => {
        roots.forEach(root => { root.hidden = !(variant && variant.available); });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
